import { useMutation } from "@tanstack/react-query";

import * as memberApi from "@core/apis/member.api";
import type { CommonUseMutationOptions } from "@core/types/app";
import type { Member } from "@core/types/member";

export default (options?: CommonUseMutationOptions<string, Member>) => {
  const mutation = useMutation({
    ...options,
    mutationFn: (memo: string) => memberApi.updateMemberMemo(memo),
  });

  return mutation;
};
